import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppBarWrapper } from "./Topbar.style";
import Filter from 'Components/Pages/Filter/Filter';

function Topbar() {

    return (
        <AppBarWrapper position="static" style={{height:"90px"}} classes={{ root: "root" }}>
            {/* <ToolbarWrapper> */}
                {/* <LinksWrapper> */}
                    <Filter />
                {/* </LinksWrapper> */}
            {/* </ToolbarWrapper> */}
        </AppBarWrapper>
    );
}

export default withRouter(Topbar);